(function (){
    'use strict';

    angular
        .module('services')
        .service('LoyaltyService', LoyaltyService);

    LoyaltyService.$inject = ['$http', 'API_BASE'];

    function LoyaltyService ($http, API_BASE) {
        var service = this;

        service.getProgramItems = getProgramItems;
        service.getProgramItemsForSelect = getProgramItemsForSelect;
        service.createProgramItem = createProgramItem;
        service.deleteProgramItem = deleteProgramItem;
        service.updateProgramItem = updateProgramItem;
        service.getItemUsers = getItemUsers;
        service.reverseRedeem = reverseRedeem;
        service.getExpiringPoints = getExpiringPoints;
        service.getExpiringPointsCSV = getExpiringPointsCSV;

        function getProgramItems (query) {
            return $http.get(API_BASE + '/loyalty/items',{params:query});
        }

        function getProgramItemsForSelect (query) {
            return $http.get(API_BASE + '/loyalty/items/select',{params:query});
        }

        function createProgramItem (query) {

            return $http.post(API_BASE + '/loyalty/items/store',query, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });
        }

        function deleteProgramItem (query) {
            return $http.post(API_BASE + '/loyalty/items/delete',query);
        }

        function updateProgramItem (query) {
            return $http.post(API_BASE + '/loyalty/items/update', query, {
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });
        }

        function getItemUsers (query) {
            return $http.get(API_BASE + '/loyalty/items/users',{params:query});
        }

        function reverseRedeem (query) {
            return $http.post(API_BASE + '/loyalty/items/users/reverse',query);
        }

        function getExpiringPoints (query) {
            return $http.get(API_BASE + '/loyalty/expiring',{params:query});
        }

        function getExpiringPointsCSV (query) {
            return $http.get(API_BASE + '/loyalty/expiring/csv',{params:query});
        }
    }
})();